import { z } from "zod";

const geofenceSchema = z.object({
	type: z.string(),
	coordinates: z.array(z.array(z.array(z.tuple([z.number(), z.number()])))),
});
export const subsiteSchema = z.object({
	id: z.number(),
	name: z.string(),
	description: z.string(),
	geofence: geofenceSchema.nullable(),
	site_manager_name: z.string(),
	site_manager_title: z.string(),
	type: z.union([z.literal("Trees"), z.literal("Kelp")]),
	region_id: z.number(),
	country_id: z.number(),
	forest_type_id: z.number(),
	forest_type_name: z.string(),
	total_planters: z.number(),
	subsite_main_image_url: z
		.object({
			id: z.number(),
			url: z.string(),
			cdn_url: z.string(),
		})
		.nullable(),
	subsite_area: z.number(),
	legacy: z.boolean(),
	legacy_trees: z.number(),
	legacy_kelp: z.number(),
	trees_ordered: z.number().optional(),
	trees_planted: z.number().optional(),
	trees_designated: z.number().optional(),
	kelp_ordered: z.number().optional(),
	kelp_planted: z.number().optional(),
	kelp_designated: z.number().optional(),
});
export const regionSchema = z.object({
	id: z.number(),
	name: z.string(),
	center_lat: z.number().nullable(),
	center_lng: z.number().nullable(),
	center_long: z.number().nullable(),
	organization: z.object({
		id: z.number(),
		name: z.string(),
	}),
	country_id: z.number(),
	geofence: geofenceSchema,
	subsites: z.array(subsiteSchema),
});
export const plantingDataSchema = z.object({
	_result: z.object({
		http_code: z.number(),
	}),
	data: z.array(
		z.object({
			id: z.number(),
			name: z.string(),
			lat: z.string(),
			long: z.string(),
			regions: z.array(regionSchema),
		}),
	),
});
export type PlantingDataResponse = z.infer<typeof plantingDataSchema>;
export type RawCountryPlantingData = PlantingDataResponse["data"][number];
export type RawRegionPlantingData = RawCountryPlantingData["regions"][number];
export type Organization = RawRegionPlantingData["organization"];
export type RawSubSite = RawRegionPlantingData["subsites"][number];
export type Geofence = z.infer<typeof geofenceSchema>;
